import React from 'react';

const defaultMinimumQuantity = 0;

const QuantitySelector = ({quantity, onChangeQuantity, formatValue, minimumQuantity}) => {

  let minValue = minimumQuantity ? minimumQuantity : defaultMinimumQuantity;
  return (
    <div className="quantity-selector">
      <span>{(quantity || quantity == 0) && quantity >= minValue ? (formatValue ? formatValue(quantity) : quantity) : minValue}</span>
      <div className="buttons-container">
        <i className="fa fa-plus-square" onClick={() => onIncrement()} />
        <i className="fa fa-minus-square" onClick={() => onDecrement()}/>
      </div>
    </div>
  );

  function onIncrement() {

    let newQty = quantity ? ++quantity : 1;
    console.log('New quantity', newQty);
    if(onChangeQuantity) onChangeQuantity(newQty)
  }

  function onDecrement() {

    let minValue = minimumQuantity ? minimumQuantity : defaultMinimumQuantity;
    let newQty = quantity > minValue ? --quantity : minValue;
    console.log('New quantity', newQty);
    if(onChangeQuantity) onChangeQuantity(newQty)
  }
};

export default QuantitySelector;



// WEBPACK FOOTER //
// ./src/components/commons/quantity-selector/QuantitySelector.js